import Vue from 'vue'
Vue.mixin({
    data() {
        return {
            currentrow: null
        }
    },
    methods: {
        handlerCurrentRow(row) {
            this.currentrow = row;
        },
        hasCurrentRow() {
            if (!this.currentrow) {
                this.$message.error('没有选择任何行！');
                return false
            } else {
                return true
            }

        }
    }
})


